// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Product Catalogue API
 * Endpoints for querying product catalogue data including products and their versions.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Version
 */
export interface Version {
  /**
   * The version identifier.
   * @type {string}
   * @memberof Version
   */
  version: string;
  /**
   * The date-time from which this version is valid.
   * @type {Date}
   * @memberof Version
   */
  validFrom: Date;
}

/**
 * Check if a given object implements the Version interface.
 */
export function instanceOfVersion(value: object): value is Version {
  if (!('version' in value) || value['version'] === undefined) return false;
  if (!('validFrom' in value) || value['validFrom'] === undefined) return false;
  return true;
}

export function VersionFromJSON(json: any): Version {
  return VersionFromJSONTyped(json, false);
}

export function VersionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Version {
  if (json == null) {
    return json;
  }
  return {
    version: json['version'],
    validFrom: new Date(json['validFrom']),
  };
}

export function VersionToJSON(json: any): Version {
  return VersionToJSONTyped(json, false);
}

export function VersionToJSONTyped(
  value?: Version | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    version: value['version'],
    validFrom: value['validFrom'].toISOString(),
  };
}
